var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("store::album::edit_设置商品条件"),
        visible: _vm.visible,
        "append-to-body": _vm.appendToBody,
        "close-on-click-modal": false,
        width: "690px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("p", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("store::album::edit_条件"))),
      ]),
      _c(
        "el-radio-group",
        {
          model: {
            value: _vm.condition.conditionType,
            callback: function ($$v) {
              _vm.$set(_vm.condition, "conditionType", $$v)
            },
            expression: "condition.conditionType",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "24px" } },
            [
              _c("el-radio", { attrs: { label: 1 } }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("store::album::edit_所有条件")) + " "
                ),
              ]),
              _c("span", { staticClass: "tip" }, [
                _vm._v(
                  "(" + _vm._s(_vm.$t("store::album::edit_所有条件tip")) + ")"
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "24px" } },
            [
              _c("el-radio", { attrs: { label: 2 } }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("store::album::edit_任一条件")) + " "
                ),
              ]),
              _c("span", { staticClass: "tip" }, [
                _vm._v(
                  "(" + _vm._s(_vm.$t("store::album::edit_任一条件tip")) + ")"
                ),
              ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "condition" },
        _vm._l(_vm.condition.conditions, function (i, index) {
          return _c(
            "div",
            { key: index, staticClass: "condition-item" },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "110px" },
                  on: {
                    change: function () {
                      i.condition = ""
                      i.value = ""
                    },
                  },
                  model: {
                    value: i.filterObj,
                    callback: function ($$v) {
                      _vm.$set(i, "filterObj", $$v)
                    },
                    expression: "i.filterObj",
                  },
                },
                _vm._l(_vm.conditionList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "110px", margin: "0 8px" },
                  on: {
                    change: function ($event) {
                      i.value = ""
                    },
                  },
                  model: {
                    value: i.filterType,
                    callback: function ($$v) {
                      _vm.$set(i, "filterType", $$v)
                    },
                    expression: "i.filterType",
                  },
                },
                _vm._l(_vm.getTypeList(i.filterObj), function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              i.filterObj === 2
                ? _c("el-cascader", {
                    staticClass: "input-item",
                    staticStyle: { width: "360px", "margin-right": "8px" },
                    attrs: {
                      options: _vm.categoryOpt,
                      props: {
                        label: "name",
                        value: "id",
                        children: "childrens",
                        checkStrictly: true,
                      },
                    },
                    model: {
                      value: i.target,
                      callback: function ($$v) {
                        _vm.$set(i, "target", $$v)
                      },
                      expression: "i.target",
                    },
                  })
                : i.filterObj === 4
                ? _c(
                    "el-select",
                    {
                      staticStyle: { width: "360px", "margin-right": "8px" },
                      model: {
                        value: i.target,
                        callback: function ($$v) {
                          _vm.$set(i, "target", $$v)
                        },
                        expression: "i.target",
                      },
                    },
                    _vm._l(_vm.tagOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.tagName, value: item.id },
                      })
                    }),
                    1
                  )
                : _c("el-input", {
                    staticStyle: { width: "360px", "margin-right": "8px" },
                    model: {
                      value: i.target,
                      callback: function ($$v) {
                        _vm.$set(i, "target", $$v)
                      },
                      expression: "i.target",
                    },
                  }),
              _c("i", {
                staticClass: "add-btn",
                class: index === 0 ? "el-icon-plus" : "el-icon-delete",
                on: {
                  click: function ($event) {
                    return _vm.handle(index)
                  },
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _c("p", { staticClass: "title", staticStyle: { "margin-top": "32px" } }, [
        _vm._v(" " + _vm._s(_vm.$t("store::album::edit_特殊过滤规则")) + " "),
        _c("span", { staticClass: "tip" }, [
          _vm._v(
            "( " + _vm._s(_vm.$t("store::album::edit_特殊过滤规则tip")) + ")"
          ),
        ]),
      ]),
      _c(
        "div",
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "110px" },
              model: {
                value: _vm.special.type,
                callback: function ($$v) {
                  _vm.$set(_vm.special, "type", $$v)
                },
                expression: "special.type",
              },
            },
            [_c("el-option", { attrs: { label: "SPU", value: "" } })],
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "110px", "margin-left": "8px" },
              model: {
                value: _vm.special.condition,
                callback: function ($$v) {
                  _vm.$set(_vm.special, "condition", $$v)
                },
                expression: "special.condition",
              },
            },
            [
              _c("el-option", {
                attrs: { label: _vm.$t("store::album::edit_包含"), value: "" },
              }),
            ],
            1
          ),
          _c("el-input", {
            staticStyle: { "margin-top": "16px" },
            attrs: {
              type: "textarea",
              rows: 4,
              placeholder: _vm.$t("store::album::edit_tip"),
            },
            model: {
              value: _vm.condition.filterSpuIds,
              callback: function ($$v) {
                _vm.$set(_vm.condition, "filterSpuIds", $$v)
              },
              expression: "condition.filterSpuIds",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.loading },
              on: { click: _vm.sumbit },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }